import React from "react";
import OrderTable from "./components/Table/OrderTable";

const Orders = () => {
    return (
        <div>
            <OrderTable />
        </div>
    );
};

export default Orders;
